import styled from "styled-components";

export const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1em;
  width: 100%;
  @media screen and (max-width: 1024px) {
//   padding-bottom: 2em;
  }
`;

export const HeaderImage = styled.img`
  max-width: 100%;
  height: ${(props) => props.height};
  @media screen and (max-width: 1024px) {
    width: ${(props) => props.mwidth};
    height: ${(props) => props.mheight};
    bottom: ${(props) => props.mbottom};
    left: ${(props) => props.mleft};
  }
`;

export const VerticalColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 1em;
`;
